import { notify } from "components";
import fileDownload from "js-file-download";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

////////////////////////// TEMPLATE - Actions //////////////////////////

export const loadTemplate = async (templateId) => {
  try {
    const response = await axios.get("/template/" + templateId + "/");
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Template fetched successfully!", "success");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template could not be fetched!");
  }
};

export const templateToPDF = async (templateId) => {
  try {
    const response = await axios.post(
      "/template/" + templateId + "/print_pdf/",
      {},
      {
        responseType: "blob",
      }
    );
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Template fetched successfully!", "success");
      fileDownload(response.data, "template.pdf");
      // return response.data;
    }
    console.log("FILE DOWNLOAD RESPONSE:", response);
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template could not be downloaded!");
  }
};

export const templateToPDFPreview = async (templateId) => {
  try {
    const response = await axios.post(
      "/template/" + templateId + "/print_pdf/",
      {},
      {
        responseType: "blob",
      }
    );
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Template fetched successfully!", "success");
      // fileDownload(response.data, "template.html");
      return response.data;
    }
    console.log("FILE DOWNLOAD RESPONSE:", response);
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template could not be downloaded!");
  }
};

export const loadTemplates = async (page, searchValue) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/template/?page=${page}&page_size=100`;
    if (searchValue) {
      url += `&search=${searchValue}`;
    }
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Templates fetched successfully!", "success");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "There was a problem loading Templates!");
  }
};

export const createTemplate = async (data) => {
  try {
    const response = await axios.post(`/template/`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response", response);
    if (response.status === 201) {
      notify("success", "Your Template has been saved!");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template could not be saved!");
  }
};

export const updateTemplate = async (templateId, data) => {
  try {
    const response = await axios.put(`/template/${templateId}/`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response", response);
    if (response.status === 200) {
      notify("success", "Updated the template");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template could not be updated!");
  }
};

export const deleteTemplate = async (id) => {
  try {
    const response = await axios.delete(`/template/${id}/`);
    console.log("Response", response);
    notify("success", "Template deleted successfully");
    return "deleted";
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template deleted Error");
  }
};

export const loadTemplateTypes = async () => {
  try {
    const response = await axios.get(`/template/template_types/`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Templates fetched successfully!", "success");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "There was a problem loading Template Types!");
  }
};

////////////////////////// 2FA - Actions //////////////////////////

export const checkUser2FAStatus = async (email) => {
  try {
    const response = await axios.post("/user/check-2fa-status/", { email });
    if (response.status === 200) {
      return {
        requires2FA: response.data.is_2fa_enabled,
        email: response.data.email,
        firstName: response.data.first_name,
        lastName: response.data.last_name
      };
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to check user status. Please try again.");
    throw err;
  }
};

export const sendLoginOTP = async (email) => {
  try {
    const response = await axios.post("/user/login-otp/", { email });
    if (response.status === 200) {
      notify("success", "OTP sent to your email!");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to send OTP. Please try again.");
    throw err;
  }
};

export const verifyLoginOTP = async (email, otp_code) => {
  try {
    const response = await axios.post("/user/verify-login-otp/", { email, otp_code });
    if (response.status === 200) {
      notify("success", "Login successful!");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Invalid OTP. Please try again.");
    throw err;
  }
};

export const resendLoginOTP = async (email) => {
  try {
    const response = await axios.post("/user/resend-otp/", { email, otp_type: "login" });
    if (response.status === 200) {
      notify("success", "OTP resent to your email!");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to resend OTP. Please try again.");
    throw err;
  }
};

////////////////////////// QUOTE LINES IMPORT / EXPORT - Actions //////////////////////////

/**
 * Pull a filename out of a Content-Disposition header, falling back to a default.
 * @param {Object} headers - Axios response headers
 * @param {string} fallback - Name to use when the header is absent
 * @returns {string}
 */
const filenameFromHeaders = (headers, fallback) => {
  const disposition = headers?.["content-disposition"];
  const match = disposition && disposition.match(/filename="?([^"]+)"?/);
  return match ? match[1] : fallback;
};

/**
 * Export a quote's current lines as an Excel file.
 * The file carries each line's id, so it can be edited and imported back to
 * update those lines rather than duplicate them.
 * @param {string} quoteId - Quote UUID
 * @returns {Promise<Blob>} Excel file blob
 */
export const exportQuoteLines = async (quoteId) => {
  try {
    const response = await axios.get(`/quotes/quotes/${quoteId}/export_quote_lines/`, {
      responseType: "blob",
    });
    if (response.status === 200) {
      fileDownload(
        response.data,
        filenameFromHeaders(response.headers, "quote_lines.xlsx")
      );
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to export quote lines!");
    throw err;
  }
};

/**
 * Download Excel template for quote line import
 * @returns {Promise<Blob>} Excel file blob
 */
export const downloadQuoteLinesTemplate = async () => {
  try {
    const response = await axios.get("/quotes/quotes/download_quote_lines_template/", {
      responseType: "blob",
    });
    if (response.status === 200) {
      fileDownload(response.data, "quote_lines_template.xlsx");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to download template!");
    throw err;
  }
};

/**
 * Import quote lines from Excel file
 * @param {File} file - Excel file to import
 * @param {string} [quoteId] - Quote the file belongs to. When given, line ids in
 *   the file are checked against that quote so a file exported from a different
 *   quote is caught here rather than at save time.
 * @returns {Promise<{success: boolean, items: Array, errors: Array, message: string}>}
 */
export const importQuoteLines = async (file, quoteId) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (quoteId) {
      formData.append("quote", quoteId);
    }
    const response = await axios.post("/quotes/quotes/import_quote_lines/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    if (err.response && err.response.data && err.response.data.error) {
      notify("error", err.response.data.error);
    } else {
      notify("error", "Failed to import quote lines!");
    }
    throw err;
  }
};

////////////////////////// INVOICE LINES IMPORT - Actions //////////////////////////

/**
 * Export an invoice's current lines as an Excel file.
 * The file carries each line's id, so it can be edited and imported back to
 * update those lines rather than duplicate them.
 * @param {string} invoiceId - Invoice UUID
 * @returns {Promise<Blob>} Excel file blob
 */
export const exportInvoiceLines = async (invoiceId) => {
  try {
    const response = await axios.get(`/invoices/invoices/${invoiceId}/export_invoice_lines/`, {
      responseType: "blob",
    });
    if (response.status === 200) {
      fileDownload(
        response.data,
        filenameFromHeaders(response.headers, "invoice_lines.xlsx")
      );
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to export invoice lines!");
    throw err;
  }
};

/**
 * Download Excel template for invoice line import
 * @returns {Promise<Blob>} Excel file blob
 */
export const downloadInvoiceLinesTemplate = async () => {
  try {
    const response = await axios.get("/invoices/invoices/download_invoice_lines_template/", {
      responseType: "blob",
    });
    if (response.status === 200) {
      fileDownload(response.data, "invoice_lines_template.xlsx");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to download template!");
    throw err;
  }
};

/**
 * Import invoice lines from Excel file
 * @param {File} file - Excel file to import
 * @param {string} [invoiceId] - Invoice the file belongs to. When given, line ids
 *   in the file are checked against that invoice so a file exported from a
 *   different invoice is caught here rather than at save time.
 * @returns {Promise<{success: boolean, items: Array, errors: Array, message: string}>}
 */
export const importInvoiceLines = async (file, invoiceId) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (invoiceId) {
      formData.append("invoice", invoiceId);
    }
    const response = await axios.post("/invoices/invoices/import_invoice_lines/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    if (err.response && err.response.data && err.response.data.error) {
      notify("error", err.response.data.error);
    } else {
      notify("error", "Failed to import invoice lines!");
    }
    throw err;
  }
};
